<template lang="pug">
.markers(:class="{ edit }")
    .contents(:class="{ 'is-dragging': dragging }")
        .alert.info(v-if="!contents.filter(el => el.key === 'marker' && checkConditions(el)).length")
            p {{ $t("You haven't set any pins yet") }}
        template(v-else)
            draggable(
                v-model="contents"
                :group="`${section.id}:contents`"
                :disabled="!edit"
                handle="h4.handle"
                :options="{ forceFallback: true }"
                drag-class="custom-ghost"
                @start="dragging = true"
                @end="dragging = false"
            )
                transition-group(name="slide-decent-vertical")
                    .group(v-for="(content, i) in contents" :key="content.id")
                        //- v-if="checkConditions(content) && edit"
                        marker-content(
                            :key="content.id"
                            :section="section"
                            :content="content"
                            :options="options"
                            :config="config"
                            :index="i"
                            :section-setting-values="sectionSettingValues"
                            :sortable="sortable"
                            :edit="edit"
                        )
        el-button.add-content(
            v-if="allowedToAddContent && edit"
            round
            type="success"
            size="mini"
            icon="el-icon-fa-plus fas"
            @click="addContent"
        ) {{ $t('Marker') }}
</template>

<i18n>
{
    "de": {
        "Marker": "Pin",
        "You haven't set any pins yet": "Es wurden noch keine Pins festgelegt"
    }
}
</i18n>

<script>
import _ from 'lodash'

import InputContents from '@/components/Page/Sections/Partials/InputContents'
import MarkerContent from './MarkerContent'

export default {
    name: 'Markers',
    extends: InputContents,
    components: {
        MarkerContent,
    },
}
</script>

<style lang="sass" scoped>
.alert
    margin: 0

// .contents > .content:first-child
    margin-top: 1rem

.content + .content:not(.email-content)
    margin-top: 2rem
    padding-top: 2rem
    // border-top: 3px dotted $--color-primary

button.add-content
    margin-top: 1rem
    margin-bottom: .5rem
</style>
